// source: pangolin/protos/hosts.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pangolin.protos.GetHostHistoryResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetHostResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetHostThroughputResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetHostsResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.HostDeviceType', null, global);
goog.exportSymbol('proto.pangolin.protos.HostError', null, global);
goog.exportSymbol('proto.pangolin.protos.HostErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.HostErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.HostHistoryDirection', null, global);
goog.exportSymbol('proto.pangolin.protos.HostHistoryLocationObject', null, global);
goog.exportSymbol('proto.pangolin.protos.HostHistoryObject', null, global);
goog.exportSymbol('proto.pangolin.protos.HostHistoryObjectList', null, global);
goog.exportSymbol('proto.pangolin.protos.HostObject', null, global);
goog.exportSymbol('proto.pangolin.protos.HostObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.HostObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.HostThroughputObject', null, global);
goog.exportSymbol('proto.pangolin.protos.HostThroughputObjectList', null, global);
goog.exportSymbol('proto.pangolin.protos.SetHostRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetHostResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetHostsRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetHostsResponseInvalid', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostHistoryLocationObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.HostHistoryLocationObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostHistoryLocationObject.displayName = 'proto.pangolin.protos.HostHistoryLocationObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostHistoryObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostHistoryObject.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostHistoryObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostHistoryObject.displayName = 'proto.pangolin.protos.HostHistoryObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostHistoryObjectList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostHistoryObjectList.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostHistoryObjectList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostHistoryObjectList.displayName = 'proto.pangolin.protos.HostHistoryObjectList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostThroughputObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.HostThroughputObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostThroughputObject.displayName = 'proto.pangolin.protos.HostThroughputObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostThroughputObjectList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostThroughputObjectList.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostThroughputObjectList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostThroughputObjectList.displayName = 'proto.pangolin.protos.HostThroughputObjectList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.HostObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostObject.displayName = 'proto.pangolin.protos.HostObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostObjectMap.displayName = 'proto.pangolin.protos.HostObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.HostObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostObjectMapTuple.displayName = 'proto.pangolin.protos.HostObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostError.displayName = 'proto.pangolin.protos.HostError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.HostErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.HostErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostErrorMap.displayName = 'proto.pangolin.protos.HostErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.HostErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.HostErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.HostErrorMapTuple.displayName = 'proto.pangolin.protos.HostErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetHostsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetHostsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetHostsResponse.displayName = 'proto.pangolin.protos.GetHostsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetHostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetHostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetHostsRequest.displayName = 'proto.pangolin.protos.SetHostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetHostsResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetHostsResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetHostsResponseInvalid.displayName = 'proto.pangolin.protos.SetHostsResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetHostResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetHostResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetHostResponse.displayName = 'proto.pangolin.protos.GetHostResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetHostRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetHostRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetHostRequest.displayName = 'proto.pangolin.protos.SetHostRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetHostResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetHostResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetHostResponseInvalid.displayName = 'proto.pangolin.protos.SetHostResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetHostHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetHostHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetHostHistoryResponse.displayName = 'proto.pangolin.protos.GetHostHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetHostThroughputResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetHostThroughputResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetHostThroughputResponse.displayName = 'proto.pangolin.protos.GetHostThroughputResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostHistoryLocationObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostHistoryLocationObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryLocationObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    countryShort: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    countryLong: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    region: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    city: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    zipcode: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    timezone: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    ip: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    longitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 8)) == null ? undefined : f,
    latitude: (f = jspb.Message.getOptionalFloatingPointField(msg, 9)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject}
 */
proto.pangolin.protos.HostHistoryLocationObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostHistoryLocationObject;
  return proto.pangolin.protos.HostHistoryLocationObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostHistoryLocationObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject}
 */
proto.pangolin.protos.HostHistoryLocationObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryShort(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryLong(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipcode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimezone(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLongitude(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatitude(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostHistoryLocationObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostHistoryLocationObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryLocationObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeDouble(
      9,
      f
    );
  }
};


/**
 * optional string country_short = 1;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getCountryShort = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setCountryShort = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearCountryShort = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasCountryShort = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string country_long = 2;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getCountryLong = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setCountryLong = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearCountryLong = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasCountryLong = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string region = 3;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setRegion = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearRegion = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasRegion = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setCity = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearCity = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasCity = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string zipcode = 5;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getZipcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setZipcode = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearZipcode = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasZipcode = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string timezone = 6;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getTimezone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setTimezone = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearTimezone = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasTimezone = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string ip = 7;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setIp = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearIp = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasIp = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double longitude = 8;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getLongitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setLongitude = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearLongitude = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasLongitude = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double latitude = 9;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.getLatitude = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.setLatitude = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryLocationObject} returns this
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.clearLatitude = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryLocationObject.prototype.hasLatitude = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostHistoryObject.repeatedFields_ = [19,20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostHistoryObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostHistoryObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostHistoryObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    order: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    ctid: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    start: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    last: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    direction: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    macSrc: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    macDst: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    protoL3: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    addrSrc: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    addrDst: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    protoL4: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    portSrc: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    portDst: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
    pktsOrig: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
    pktsRepl: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
    bytesOrig: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
    bytesRepl: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
    allowed: (f = jspb.Message.getBooleanField(msg, 18)) == null ? undefined : f,
    domainsSrcList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    domainsDstList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    locationSrc: (f = msg.getLocationSrc()) && proto.pangolin.protos.HostHistoryLocationObject.toObject(includeInstance, f),
    locationDst: (f = msg.getLocationDst()) && proto.pangolin.protos.HostHistoryLocationObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostHistoryObject}
 */
proto.pangolin.protos.HostHistoryObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostHistoryObject;
  return proto.pangolin.protos.HostHistoryObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostHistoryObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostHistoryObject}
 */
proto.pangolin.protos.HostHistoryObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOrder(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCtid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setStart(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setLast(value);
      break;
    case 5:
      var value = /** @type {!proto.pangolin.protos.HostHistoryDirection} */ (reader.readEnum());
      msg.setDirection(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacSrc(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMacDst(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtoL3(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrSrc(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrDst(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setProtoL4(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPortSrc(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPortDst(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPktsOrig(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPktsRepl(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesOrig(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBytesRepl(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowed(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomainsSrc(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addDomainsDst(value);
      break;
    case 21:
      var value = new proto.pangolin.protos.HostHistoryLocationObject;
      reader.readMessage(value,proto.pangolin.protos.HostHistoryLocationObject.deserializeBinaryFromReader);
      msg.setLocationSrc(value);
      break;
    case 22:
      var value = new proto.pangolin.protos.HostHistoryLocationObject;
      reader.readMessage(value,proto.pangolin.protos.HostHistoryLocationObject.deserializeBinaryFromReader);
      msg.setLocationDst(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostHistoryObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostHistoryObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostHistoryObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.HostHistoryDirection} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeUint64(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeUint64(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeUint64(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getDomainsSrcList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getDomainsDstList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getLocationSrc();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.pangolin.protos.HostHistoryLocationObject.serializeBinaryToWriter
    );
  }
  f = message.getLocationDst();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.pangolin.protos.HostHistoryLocationObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 order = 1;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setOrder = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearOrder = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 ctid = 2;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getCtid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setCtid = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearCtid = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasCtid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 start = 3;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setStart = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearStart = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasStart = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 last = 4;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getLast = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setLast = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearLast = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasLast = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional HostHistoryDirection direction = 5;
 * @return {!proto.pangolin.protos.HostHistoryDirection}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getDirection = function() {
  return /** @type {!proto.pangolin.protos.HostHistoryDirection} */ (jspb.Message.getFieldWithDefault(this, 5, 1));
};


/**
 * @param {!proto.pangolin.protos.HostHistoryDirection} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setDirection = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearDirection = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasDirection = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string mac_src = 6;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getMacSrc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setMacSrc = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearMacSrc = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasMacSrc = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string mac_dst = 7;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getMacDst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setMacDst = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearMacDst = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasMacDst = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint32 proto_l3 = 8;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getProtoL3 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setProtoL3 = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearProtoL3 = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasProtoL3 = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string addr_src = 9;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getAddrSrc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setAddrSrc = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearAddrSrc = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasAddrSrc = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string addr_dst = 10;
 * @return {string}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getAddrDst = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setAddrDst = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearAddrDst = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasAddrDst = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint32 proto_l4 = 11;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getProtoL4 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setProtoL4 = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearProtoL4 = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasProtoL4 = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional uint32 port_src = 12;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getPortSrc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setPortSrc = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearPortSrc = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasPortSrc = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional uint32 port_dst = 13;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getPortDst = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setPortDst = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearPortDst = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasPortDst = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional uint64 pkts_orig = 14;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getPktsOrig = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setPktsOrig = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearPktsOrig = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasPktsOrig = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional uint64 pkts_repl = 15;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getPktsRepl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setPktsRepl = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearPktsRepl = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasPktsRepl = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional uint64 bytes_orig = 16;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getBytesOrig = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setBytesOrig = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearBytesOrig = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasBytesOrig = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional uint64 bytes_repl = 17;
 * @return {number}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getBytesRepl = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setBytesRepl = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearBytesRepl = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasBytesRepl = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool allowed = 18;
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setAllowed = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearAllowed = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasAllowed = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated string domains_src = 19;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getDomainsSrcList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setDomainsSrcList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.addDomainsSrc = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearDomainsSrcList = function() {
  return this.setDomainsSrcList([]);
};


/**
 * repeated string domains_dst = 20;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getDomainsDstList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.setDomainsDstList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.addDomainsDst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearDomainsDstList = function() {
  return this.setDomainsDstList([]);
};


/**
 * optional HostHistoryLocationObject location_src = 21;
 * @return {?proto.pangolin.protos.HostHistoryLocationObject}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getLocationSrc = function() {
  return /** @type{?proto.pangolin.protos.HostHistoryLocationObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostHistoryLocationObject, 21));
};


/**
 * @param {?proto.pangolin.protos.HostHistoryLocationObject|undefined} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
*/
proto.pangolin.protos.HostHistoryObject.prototype.setLocationSrc = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearLocationSrc = function() {
  return this.setLocationSrc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasLocationSrc = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional HostHistoryLocationObject location_dst = 22;
 * @return {?proto.pangolin.protos.HostHistoryLocationObject}
 */
proto.pangolin.protos.HostHistoryObject.prototype.getLocationDst = function() {
  return /** @type{?proto.pangolin.protos.HostHistoryLocationObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostHistoryLocationObject, 22));
};


/**
 * @param {?proto.pangolin.protos.HostHistoryLocationObject|undefined} value
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
*/
proto.pangolin.protos.HostHistoryObject.prototype.setLocationDst = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.HostHistoryObject} returns this
 */
proto.pangolin.protos.HostHistoryObject.prototype.clearLocationDst = function() {
  return this.setLocationDst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostHistoryObject.prototype.hasLocationDst = function() {
  return jspb.Message.getField(this, 22) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostHistoryObjectList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostHistoryObjectList.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostHistoryObjectList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostHistoryObjectList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryObjectList.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.HostHistoryObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostHistoryObjectList}
 */
proto.pangolin.protos.HostHistoryObjectList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostHistoryObjectList;
  return proto.pangolin.protos.HostHistoryObjectList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostHistoryObjectList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostHistoryObjectList}
 */
proto.pangolin.protos.HostHistoryObjectList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostHistoryObject;
      reader.readMessage(value,proto.pangolin.protos.HostHistoryObject.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostHistoryObjectList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostHistoryObjectList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostHistoryObjectList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostHistoryObjectList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.HostHistoryObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HostHistoryObject items = 1;
 * @return {!Array<!proto.pangolin.protos.HostHistoryObject>}
 */
proto.pangolin.protos.HostHistoryObjectList.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.HostHistoryObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.HostHistoryObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.HostHistoryObject>} value
 * @return {!proto.pangolin.protos.HostHistoryObjectList} returns this
*/
proto.pangolin.protos.HostHistoryObjectList.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.HostHistoryObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostHistoryObject}
 */
proto.pangolin.protos.HostHistoryObjectList.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.HostHistoryObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostHistoryObjectList} returns this
 */
proto.pangolin.protos.HostHistoryObjectList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostThroughputObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostThroughputObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostThroughputObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostThroughputObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeStart: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    timeEnd: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    extTxPkts: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    extTxBytes: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    extRxPkts: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    extRxBytes: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
    intTxPkts: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    intTxBytes: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    intRxPkts: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    intRxBytes: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    allTxPkts: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    allTxBytes: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
    allRxPkts: (f = jspb.Message.getField(msg, 13)) == null ? undefined : f,
    allRxBytes: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostThroughputObject}
 */
proto.pangolin.protos.HostThroughputObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostThroughputObject;
  return proto.pangolin.protos.HostThroughputObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostThroughputObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostThroughputObject}
 */
proto.pangolin.protos.HostThroughputObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimeStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimeEnd(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExtTxPkts(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExtTxBytes(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExtRxPkts(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExtRxBytes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntTxPkts(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntTxBytes(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntRxPkts(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setIntRxBytes(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllTxPkts(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllTxBytes(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllRxPkts(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAllRxBytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostThroughputObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostThroughputObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostThroughputObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostThroughputObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeUint64(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeUint64(
      14,
      f
    );
  }
};


/**
 * optional uint64 time_start = 1;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getTimeStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setTimeStart = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearTimeStart = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasTimeStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 time_end = 2;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getTimeEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setTimeEnd = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearTimeEnd = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasTimeEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint64 ext_tx_pkts = 3;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getExtTxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setExtTxPkts = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearExtTxPkts = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasExtTxPkts = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional uint64 ext_tx_bytes = 4;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getExtTxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setExtTxBytes = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearExtTxBytes = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasExtTxBytes = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint64 ext_rx_pkts = 5;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getExtRxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setExtRxPkts = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearExtRxPkts = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasExtRxPkts = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional uint64 ext_rx_bytes = 6;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getExtRxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setExtRxBytes = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearExtRxBytes = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasExtRxBytes = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional uint64 int_tx_pkts = 7;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getIntTxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setIntTxPkts = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearIntTxPkts = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasIntTxPkts = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional uint64 int_tx_bytes = 8;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getIntTxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setIntTxBytes = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearIntTxBytes = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasIntTxBytes = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 int_rx_pkts = 9;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getIntRxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setIntRxPkts = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearIntRxPkts = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasIntRxPkts = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint64 int_rx_bytes = 10;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getIntRxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setIntRxBytes = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearIntRxBytes = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasIntRxBytes = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint64 all_tx_pkts = 11;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getAllTxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setAllTxPkts = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearAllTxPkts = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasAllTxPkts = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional uint64 all_tx_bytes = 12;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getAllTxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setAllTxBytes = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearAllTxBytes = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasAllTxBytes = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional uint64 all_rx_pkts = 13;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getAllRxPkts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setAllRxPkts = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearAllRxPkts = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasAllRxPkts = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional uint64 all_rx_bytes = 14;
 * @return {number}
 */
proto.pangolin.protos.HostThroughputObject.prototype.getAllRxBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.setAllRxBytes = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostThroughputObject} returns this
 */
proto.pangolin.protos.HostThroughputObject.prototype.clearAllRxBytes = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostThroughputObject.prototype.hasAllRxBytes = function() {
  return jspb.Message.getField(this, 14) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostThroughputObjectList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostThroughputObjectList.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostThroughputObjectList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostThroughputObjectList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostThroughputObjectList.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.HostThroughputObject.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostThroughputObjectList}
 */
proto.pangolin.protos.HostThroughputObjectList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostThroughputObjectList;
  return proto.pangolin.protos.HostThroughputObjectList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostThroughputObjectList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostThroughputObjectList}
 */
proto.pangolin.protos.HostThroughputObjectList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostThroughputObject;
      reader.readMessage(value,proto.pangolin.protos.HostThroughputObject.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostThroughputObjectList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostThroughputObjectList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostThroughputObjectList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostThroughputObjectList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.HostThroughputObject.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HostThroughputObject items = 1;
 * @return {!Array<!proto.pangolin.protos.HostThroughputObject>}
 */
proto.pangolin.protos.HostThroughputObjectList.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.HostThroughputObject>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.HostThroughputObject, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.HostThroughputObject>} value
 * @return {!proto.pangolin.protos.HostThroughputObjectList} returns this
*/
proto.pangolin.protos.HostThroughputObjectList.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.HostThroughputObject=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostThroughputObject}
 */
proto.pangolin.protos.HostThroughputObjectList.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.HostThroughputObject, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostThroughputObjectList} returns this
 */
proto.pangolin.protos.HostThroughputObjectList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    mac: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    seen: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    ip: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    up: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
    gateway: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    name: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f,
    os: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
    osHuman: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
    device: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
    deviceHuman: (f = jspb.Message.getField(msg, 11)) == null ? undefined : f,
    allocUpload: (f = jspb.Message.getOptionalFloatingPointField(msg, 12)) == null ? undefined : f,
    allocDownload: (f = jspb.Message.getOptionalFloatingPointField(msg, 13)) == null ? undefined : f,
    userName: (f = jspb.Message.getField(msg, 14)) == null ? undefined : f,
    userDevice: (f = jspb.Message.getField(msg, 15)) == null ? undefined : f,
    userOs: (f = jspb.Message.getField(msg, 16)) == null ? undefined : f,
    blockInternet: (f = jspb.Message.getBooleanField(msg, 17)) == null ? undefined : f,
    blockInternal: (f = jspb.Message.getBooleanField(msg, 25)) == null ? undefined : f,
    blockAdtracking: (f = jspb.Message.getBooleanField(msg, 18)) == null ? undefined : f,
    blockMalicious: (f = jspb.Message.getBooleanField(msg, 19)) == null ? undefined : f,
    ignoreSchedules: (f = jspb.Message.getBooleanField(msg, 20)) == null ? undefined : f,
    ignoreAll: (f = jspb.Message.getBooleanField(msg, 26)) == null ? undefined : f,
    notifyOnUp: (f = jspb.Message.getBooleanField(msg, 21)) == null ? undefined : f,
    masquerade: (f = jspb.Message.getBooleanField(msg, 22)) == null ? undefined : f,
    guest: (f = jspb.Message.getBooleanField(msg, 23)) == null ? undefined : f,
    virtual: (f = jspb.Message.getBooleanField(msg, 24)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostObject}
 */
proto.pangolin.protos.HostObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostObject;
  return proto.pangolin.protos.HostObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostObject}
 */
proto.pangolin.protos.HostObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMac(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSeen(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUp(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGateway(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setOs(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOsHuman(value);
      break;
    case 10:
      var value = /** @type {!proto.pangolin.protos.HostDeviceType} */ (reader.readEnum());
      msg.setDevice(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeviceHuman(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAllocUpload(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAllocDownload(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 15:
      var value = /** @type {!proto.pangolin.protos.HostDeviceType} */ (reader.readEnum());
      msg.setUserDevice(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserOs(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlockInternet(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlockInternal(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlockAdtracking(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBlockMalicious(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreSchedules(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIgnoreAll(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotifyOnUp(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMasquerade(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGuest(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVirtual(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.HostDeviceType} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeFloat(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.HostDeviceType} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 25));
  if (f != null) {
    writer.writeBool(
      25,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeBool(
      19,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeBool(
      20,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeBool(
      26,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 21));
  if (f != null) {
    writer.writeBool(
      21,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeBool(
      22,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 23));
  if (f != null) {
    writer.writeBool(
      23,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 24));
  if (f != null) {
    writer.writeBool(
      24,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string mac = 2;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getMac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setMac = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearMac = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasMac = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string seen = 3;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getSeen = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setSeen = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearSeen = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasSeen = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string ip = 4;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setIp = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearIp = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasIp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool up = 5;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getUp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setUp = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearUp = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasUp = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool gateway = 6;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getGateway = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setGateway = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearGateway = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasGateway = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setName = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearName = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasName = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string os = 8;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setOs = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearOs = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasOs = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string os_human = 9;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getOsHuman = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setOsHuman = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearOsHuman = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasOsHuman = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional HostDeviceType device = 10;
 * @return {!proto.pangolin.protos.HostDeviceType}
 */
proto.pangolin.protos.HostObject.prototype.getDevice = function() {
  return /** @type {!proto.pangolin.protos.HostDeviceType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.pangolin.protos.HostDeviceType} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setDevice = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearDevice = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasDevice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string device_human = 11;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getDeviceHuman = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setDeviceHuman = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearDeviceHuman = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasDeviceHuman = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional float alloc_upload = 12;
 * @return {number}
 */
proto.pangolin.protos.HostObject.prototype.getAllocUpload = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setAllocUpload = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearAllocUpload = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasAllocUpload = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional float alloc_download = 13;
 * @return {number}
 */
proto.pangolin.protos.HostObject.prototype.getAllocDownload = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setAllocDownload = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearAllocDownload = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasAllocDownload = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string user_name = 14;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setUserName = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearUserName = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasUserName = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional HostDeviceType user_device = 15;
 * @return {!proto.pangolin.protos.HostDeviceType}
 */
proto.pangolin.protos.HostObject.prototype.getUserDevice = function() {
  return /** @type {!proto.pangolin.protos.HostDeviceType} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.pangolin.protos.HostDeviceType} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setUserDevice = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearUserDevice = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasUserDevice = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string user_os = 16;
 * @return {string}
 */
proto.pangolin.protos.HostObject.prototype.getUserOs = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setUserOs = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearUserOs = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasUserOs = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool block_internet = 17;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getBlockInternet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setBlockInternet = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearBlockInternet = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasBlockInternet = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool block_internal = 25;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getBlockInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setBlockInternal = function(value) {
  return jspb.Message.setField(this, 25, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearBlockInternal = function() {
  return jspb.Message.setField(this, 25, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasBlockInternal = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool block_adtracking = 18;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getBlockAdtracking = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setBlockAdtracking = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearBlockAdtracking = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasBlockAdtracking = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional bool block_malicious = 19;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getBlockMalicious = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setBlockMalicious = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearBlockMalicious = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasBlockMalicious = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional bool ignore_schedules = 20;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getIgnoreSchedules = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setIgnoreSchedules = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearIgnoreSchedules = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasIgnoreSchedules = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional bool ignore_all = 26;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getIgnoreAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setIgnoreAll = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearIgnoreAll = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasIgnoreAll = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool notify_on_up = 21;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getNotifyOnUp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setNotifyOnUp = function(value) {
  return jspb.Message.setField(this, 21, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearNotifyOnUp = function() {
  return jspb.Message.setField(this, 21, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasNotifyOnUp = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional bool masquerade = 22;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getMasquerade = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setMasquerade = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearMasquerade = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasMasquerade = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional bool guest = 23;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getGuest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setGuest = function(value) {
  return jspb.Message.setField(this, 23, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearGuest = function() {
  return jspb.Message.setField(this, 23, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasGuest = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional bool virtual = 24;
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.getVirtual = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.setVirtual = function(value) {
  return jspb.Message.setField(this, 24, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObject} returns this
 */
proto.pangolin.protos.HostObject.prototype.clearVirtual = function() {
  return jspb.Message.setField(this, 24, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObject.prototype.hasVirtual = function() {
  return jspb.Message.getField(this, 24) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.HostObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostObjectMap}
 */
proto.pangolin.protos.HostObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostObjectMap;
  return proto.pangolin.protos.HostObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostObjectMap}
 */
proto.pangolin.protos.HostObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.HostObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.HostObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HostObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.HostObjectMapTuple>}
 */
proto.pangolin.protos.HostObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.HostObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.HostObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.HostObjectMapTuple>} value
 * @return {!proto.pangolin.protos.HostObjectMap} returns this
*/
proto.pangolin.protos.HostObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.HostObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostObjectMapTuple}
 */
proto.pangolin.protos.HostObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.HostObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostObjectMap} returns this
 */
proto.pangolin.protos.HostObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.HostObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostObjectMapTuple}
 */
proto.pangolin.protos.HostObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostObjectMapTuple;
  return proto.pangolin.protos.HostObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostObjectMapTuple}
 */
proto.pangolin.protos.HostObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.HostObject;
      reader.readMessage(value,proto.pangolin.protos.HostObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.HostObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostObjectMapTuple} returns this
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostObjectMapTuple} returns this
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional HostObject data = 2;
 * @return {?proto.pangolin.protos.HostObject}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.HostObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostObject, 2));
};


/**
 * @param {?proto.pangolin.protos.HostObject|undefined} value
 * @return {!proto.pangolin.protos.HostObjectMapTuple} returns this
*/
proto.pangolin.protos.HostObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.HostObjectMapTuple} returns this
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostError.repeatedFields_ = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,25,18,19,20,26,21,22,23,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostError.toObject = function(includeInstance, msg) {
  var f, obj = {
    idList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    macList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    seenList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    ipList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    upList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    gatewayList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    nameList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    osList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    osHumanList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    deviceList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    deviceHumanList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    allocUploadList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    allocDownloadList: (f = jspb.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
    userNameList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    userDeviceList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    userOsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f,
    blockInternetList: (f = jspb.Message.getRepeatedField(msg, 17)) == null ? undefined : f,
    blockInternalList: (f = jspb.Message.getRepeatedField(msg, 25)) == null ? undefined : f,
    blockAdtrackingList: (f = jspb.Message.getRepeatedField(msg, 18)) == null ? undefined : f,
    blockMaliciousList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    ignoreSchedulesList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    ignoreAllList: (f = jspb.Message.getRepeatedField(msg, 26)) == null ? undefined : f,
    notifyOnUpList: (f = jspb.Message.getRepeatedField(msg, 21)) == null ? undefined : f,
    masqueradeList: (f = jspb.Message.getRepeatedField(msg, 22)) == null ? undefined : f,
    guestList: (f = jspb.Message.getRepeatedField(msg, 23)) == null ? undefined : f,
    virtualList: (f = jspb.Message.getRepeatedField(msg, 24)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostError}
 */
proto.pangolin.protos.HostError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostError;
  return proto.pangolin.protos.HostError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostError}
 */
proto.pangolin.protos.HostError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addMac(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSeen(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addIp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addUp(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addGateway(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addOs(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addOsHuman(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addDevice(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addDeviceHuman(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllocUpload(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.addAllocDownload(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserDevice(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserOs(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlockInternet(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlockInternal(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlockAdtracking(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.addBlockMalicious(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addIgnoreSchedules(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.addIgnoreAll(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.addNotifyOnUp(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.addMasquerade(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.addGuest(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.addVirtual(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getMacList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getSeenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getUpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getGatewayList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getOsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getOsHumanList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getDeviceList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getDeviceHumanList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getAllocUploadList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getAllocDownloadList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      13,
      f
    );
  }
  f = message.getUserNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getUserDeviceList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
  f = message.getUserOsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
  f = message.getBlockInternetList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      17,
      f
    );
  }
  f = message.getBlockInternalList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      25,
      f
    );
  }
  f = message.getBlockAdtrackingList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      18,
      f
    );
  }
  f = message.getBlockMaliciousList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      19,
      f
    );
  }
  f = message.getIgnoreSchedulesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getIgnoreAllList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      26,
      f
    );
  }
  f = message.getNotifyOnUpList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      21,
      f
    );
  }
  f = message.getMasqueradeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      22,
      f
    );
  }
  f = message.getGuestList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      23,
      f
    );
  }
  f = message.getVirtualList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      24,
      f
    );
  }
};


/**
 * repeated string id = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearIdList = function() {
  return this.setIdList([]);
};


/**
 * repeated string mac = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getMacList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setMacList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addMac = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearMacList = function() {
  return this.setMacList([]);
};


/**
 * repeated string seen = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getSeenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setSeenList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addSeen = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearSeenList = function() {
  return this.setSeenList([]);
};


/**
 * repeated string ip = 4;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getIpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setIpList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addIp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearIpList = function() {
  return this.setIpList([]);
};


/**
 * repeated string up = 5;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getUpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setUpList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addUp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearUpList = function() {
  return this.setUpList([]);
};


/**
 * repeated string gateway = 6;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getGatewayList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setGatewayList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addGateway = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearGatewayList = function() {
  return this.setGatewayList([]);
};


/**
 * repeated string name = 7;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setNameList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addName = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearNameList = function() {
  return this.setNameList([]);
};


/**
 * repeated string os = 8;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getOsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setOsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addOs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearOsList = function() {
  return this.setOsList([]);
};


/**
 * repeated string os_human = 9;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getOsHumanList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setOsHumanList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addOsHuman = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearOsHumanList = function() {
  return this.setOsHumanList([]);
};


/**
 * repeated string device = 10;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getDeviceList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setDeviceList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addDevice = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearDeviceList = function() {
  return this.setDeviceList([]);
};


/**
 * repeated string device_human = 11;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getDeviceHumanList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setDeviceHumanList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addDeviceHuman = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearDeviceHumanList = function() {
  return this.setDeviceHumanList([]);
};


/**
 * repeated string alloc_upload = 12;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getAllocUploadList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setAllocUploadList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addAllocUpload = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearAllocUploadList = function() {
  return this.setAllocUploadList([]);
};


/**
 * repeated string alloc_download = 13;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getAllocDownloadList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 13));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setAllocDownloadList = function(value) {
  return jspb.Message.setField(this, 13, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addAllocDownload = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 13, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearAllocDownloadList = function() {
  return this.setAllocDownloadList([]);
};


/**
 * repeated string user_name = 14;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getUserNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setUserNameList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addUserName = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearUserNameList = function() {
  return this.setUserNameList([]);
};


/**
 * repeated string user_device = 15;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getUserDeviceList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setUserDeviceList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addUserDevice = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearUserDeviceList = function() {
  return this.setUserDeviceList([]);
};


/**
 * repeated string user_os = 16;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getUserOsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setUserOsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addUserOs = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearUserOsList = function() {
  return this.setUserOsList([]);
};


/**
 * repeated string block_internet = 17;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getBlockInternetList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 17));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setBlockInternetList = function(value) {
  return jspb.Message.setField(this, 17, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addBlockInternet = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 17, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearBlockInternetList = function() {
  return this.setBlockInternetList([]);
};


/**
 * repeated string block_internal = 25;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getBlockInternalList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 25));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setBlockInternalList = function(value) {
  return jspb.Message.setField(this, 25, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addBlockInternal = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 25, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearBlockInternalList = function() {
  return this.setBlockInternalList([]);
};


/**
 * repeated string block_adtracking = 18;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getBlockAdtrackingList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 18));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setBlockAdtrackingList = function(value) {
  return jspb.Message.setField(this, 18, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addBlockAdtracking = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 18, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearBlockAdtrackingList = function() {
  return this.setBlockAdtrackingList([]);
};


/**
 * repeated string block_malicious = 19;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getBlockMaliciousList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setBlockMaliciousList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addBlockMalicious = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearBlockMaliciousList = function() {
  return this.setBlockMaliciousList([]);
};


/**
 * repeated string ignore_schedules = 20;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getIgnoreSchedulesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setIgnoreSchedulesList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addIgnoreSchedules = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearIgnoreSchedulesList = function() {
  return this.setIgnoreSchedulesList([]);
};


/**
 * repeated string ignore_all = 26;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getIgnoreAllList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 26));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setIgnoreAllList = function(value) {
  return jspb.Message.setField(this, 26, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addIgnoreAll = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 26, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearIgnoreAllList = function() {
  return this.setIgnoreAllList([]);
};


/**
 * repeated string notify_on_up = 21;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getNotifyOnUpList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 21));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setNotifyOnUpList = function(value) {
  return jspb.Message.setField(this, 21, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addNotifyOnUp = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 21, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearNotifyOnUpList = function() {
  return this.setNotifyOnUpList([]);
};


/**
 * repeated string masquerade = 22;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getMasqueradeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 22));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setMasqueradeList = function(value) {
  return jspb.Message.setField(this, 22, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addMasquerade = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 22, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearMasqueradeList = function() {
  return this.setMasqueradeList([]);
};


/**
 * repeated string guest = 23;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getGuestList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 23));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setGuestList = function(value) {
  return jspb.Message.setField(this, 23, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addGuest = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 23, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearGuestList = function() {
  return this.setGuestList([]);
};


/**
 * repeated string virtual = 24;
 * @return {!Array<string>}
 */
proto.pangolin.protos.HostError.prototype.getVirtualList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 24));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.setVirtualList = function(value) {
  return jspb.Message.setField(this, 24, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.addVirtual = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 24, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostError} returns this
 */
proto.pangolin.protos.HostError.prototype.clearVirtualList = function() {
  return this.setVirtualList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.HostErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.HostErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostErrorMap}
 */
proto.pangolin.protos.HostErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostErrorMap;
  return proto.pangolin.protos.HostErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostErrorMap}
 */
proto.pangolin.protos.HostErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.HostErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.HostErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated HostErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.HostErrorMapTuple>}
 */
proto.pangolin.protos.HostErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.HostErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.HostErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.HostErrorMapTuple>} value
 * @return {!proto.pangolin.protos.HostErrorMap} returns this
*/
proto.pangolin.protos.HostErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.HostErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.HostErrorMapTuple}
 */
proto.pangolin.protos.HostErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.HostErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.HostErrorMap} returns this
 */
proto.pangolin.protos.HostErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.HostErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.HostErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    error: (f = msg.getError()) && proto.pangolin.protos.HostError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.HostErrorMapTuple}
 */
proto.pangolin.protos.HostErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.HostErrorMapTuple;
  return proto.pangolin.protos.HostErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.HostErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.HostErrorMapTuple}
 */
proto.pangolin.protos.HostErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.HostError;
      reader.readMessage(value,proto.pangolin.protos.HostError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.HostErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.HostErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.HostErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.HostError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.HostErrorMapTuple} returns this
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.HostErrorMapTuple} returns this
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional HostError error = 2;
 * @return {?proto.pangolin.protos.HostError}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.getError = function() {
  return /** @type{?proto.pangolin.protos.HostError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostError, 2));
};


/**
 * @param {?proto.pangolin.protos.HostError|undefined} value
 * @return {!proto.pangolin.protos.HostErrorMapTuple} returns this
*/
proto.pangolin.protos.HostErrorMapTuple.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.HostErrorMapTuple} returns this
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.HostErrorMapTuple.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetHostsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetHostsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetHostsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.HostObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetHostsResponse}
 */
proto.pangolin.protos.GetHostsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetHostsResponse;
  return proto.pangolin.protos.GetHostsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetHostsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetHostsResponse}
 */
proto.pangolin.protos.GetHostsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostObjectMap;
      reader.readMessage(value,proto.pangolin.protos.HostObjectMap.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetHostsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetHostsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetHostsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required HostObjectMap hosts = 1;
 * @return {!proto.pangolin.protos.HostObjectMap}
 */
proto.pangolin.protos.GetHostsResponse.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.HostObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.HostObjectMap} value
 * @return {!proto.pangolin.protos.GetHostsResponse} returns this
*/
proto.pangolin.protos.GetHostsResponse.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetHostsResponse} returns this
 */
proto.pangolin.protos.GetHostsResponse.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetHostsResponse.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetHostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetHostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetHostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.HostObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetHostsRequest}
 */
proto.pangolin.protos.SetHostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetHostsRequest;
  return proto.pangolin.protos.SetHostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetHostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetHostsRequest}
 */
proto.pangolin.protos.SetHostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostObjectMap;
      reader.readMessage(value,proto.pangolin.protos.HostObjectMap.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetHostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetHostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetHostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required HostObjectMap hosts = 1;
 * @return {!proto.pangolin.protos.HostObjectMap}
 */
proto.pangolin.protos.SetHostsRequest.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.HostObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.HostObjectMap} value
 * @return {!proto.pangolin.protos.SetHostsRequest} returns this
*/
proto.pangolin.protos.SetHostsRequest.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetHostsRequest} returns this
 */
proto.pangolin.protos.SetHostsRequest.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetHostsRequest.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetHostsResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetHostsResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetHostsResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostsResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.HostErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetHostsResponseInvalid}
 */
proto.pangolin.protos.SetHostsResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetHostsResponseInvalid;
  return proto.pangolin.protos.SetHostsResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetHostsResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetHostsResponseInvalid}
 */
proto.pangolin.protos.SetHostsResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostErrorMap;
      reader.readMessage(value,proto.pangolin.protos.HostErrorMap.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetHostsResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetHostsResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetHostsResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostsResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required HostErrorMap hosts = 1;
 * @return {!proto.pangolin.protos.HostErrorMap}
 */
proto.pangolin.protos.SetHostsResponseInvalid.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.HostErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.HostErrorMap} value
 * @return {!proto.pangolin.protos.SetHostsResponseInvalid} returns this
*/
proto.pangolin.protos.SetHostsResponseInvalid.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetHostsResponseInvalid} returns this
 */
proto.pangolin.protos.SetHostsResponseInvalid.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetHostsResponseInvalid.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetHostResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetHostResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetHostResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    host: (f = msg.getHost()) && proto.pangolin.protos.HostObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetHostResponse}
 */
proto.pangolin.protos.GetHostResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetHostResponse;
  return proto.pangolin.protos.GetHostResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetHostResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetHostResponse}
 */
proto.pangolin.protos.GetHostResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostObject;
      reader.readMessage(value,proto.pangolin.protos.HostObject.deserializeBinaryFromReader);
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetHostResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetHostResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetHostResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional HostObject host = 1;
 * @return {?proto.pangolin.protos.HostObject}
 */
proto.pangolin.protos.GetHostResponse.prototype.getHost = function() {
  return /** @type{?proto.pangolin.protos.HostObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostObject, 1));
};


/**
 * @param {?proto.pangolin.protos.HostObject|undefined} value
 * @return {!proto.pangolin.protos.GetHostResponse} returns this
*/
proto.pangolin.protos.GetHostResponse.prototype.setHost = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetHostResponse} returns this
 */
proto.pangolin.protos.GetHostResponse.prototype.clearHost = function() {
  return this.setHost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetHostResponse.prototype.hasHost = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetHostRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetHostRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetHostRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    host: (f = msg.getHost()) && proto.pangolin.protos.HostObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetHostRequest}
 */
proto.pangolin.protos.SetHostRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetHostRequest;
  return proto.pangolin.protos.SetHostRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetHostRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetHostRequest}
 */
proto.pangolin.protos.SetHostRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostObject;
      reader.readMessage(value,proto.pangolin.protos.HostObject.deserializeBinaryFromReader);
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetHostRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetHostRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetHostRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional HostObject host = 1;
 * @return {?proto.pangolin.protos.HostObject}
 */
proto.pangolin.protos.SetHostRequest.prototype.getHost = function() {
  return /** @type{?proto.pangolin.protos.HostObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostObject, 1));
};


/**
 * @param {?proto.pangolin.protos.HostObject|undefined} value
 * @return {!proto.pangolin.protos.SetHostRequest} returns this
*/
proto.pangolin.protos.SetHostRequest.prototype.setHost = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetHostRequest} returns this
 */
proto.pangolin.protos.SetHostRequest.prototype.clearHost = function() {
  return this.setHost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetHostRequest.prototype.hasHost = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetHostResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetHostResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetHostResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    host: (f = msg.getHost()) && proto.pangolin.protos.HostError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetHostResponseInvalid}
 */
proto.pangolin.protos.SetHostResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetHostResponseInvalid;
  return proto.pangolin.protos.SetHostResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetHostResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetHostResponseInvalid}
 */
proto.pangolin.protos.SetHostResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostError;
      reader.readMessage(value,proto.pangolin.protos.HostError.deserializeBinaryFromReader);
      msg.setHost(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetHostResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetHostResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetHostResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetHostResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostError.serializeBinaryToWriter
    );
  }
};


/**
 * optional HostError host = 1;
 * @return {?proto.pangolin.protos.HostError}
 */
proto.pangolin.protos.SetHostResponseInvalid.prototype.getHost = function() {
  return /** @type{?proto.pangolin.protos.HostError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostError, 1));
};


/**
 * @param {?proto.pangolin.protos.HostError|undefined} value
 * @return {!proto.pangolin.protos.SetHostResponseInvalid} returns this
*/
proto.pangolin.protos.SetHostResponseInvalid.prototype.setHost = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetHostResponseInvalid} returns this
 */
proto.pangolin.protos.SetHostResponseInvalid.prototype.clearHost = function() {
  return this.setHost(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetHostResponseInvalid.prototype.hasHost = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetHostHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetHostHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetHostHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    history: (f = msg.getHistory()) && proto.pangolin.protos.HostHistoryObjectList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetHostHistoryResponse}
 */
proto.pangolin.protos.GetHostHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetHostHistoryResponse;
  return proto.pangolin.protos.GetHostHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetHostHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetHostHistoryResponse}
 */
proto.pangolin.protos.GetHostHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostHistoryObjectList;
      reader.readMessage(value,proto.pangolin.protos.HostHistoryObjectList.deserializeBinaryFromReader);
      msg.setHistory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetHostHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetHostHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetHostHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHistory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostHistoryObjectList.serializeBinaryToWriter
    );
  }
};


/**
 * required HostHistoryObjectList history = 1;
 * @return {!proto.pangolin.protos.HostHistoryObjectList}
 */
proto.pangolin.protos.GetHostHistoryResponse.prototype.getHistory = function() {
  return /** @type{!proto.pangolin.protos.HostHistoryObjectList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostHistoryObjectList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.HostHistoryObjectList} value
 * @return {!proto.pangolin.protos.GetHostHistoryResponse} returns this
*/
proto.pangolin.protos.GetHostHistoryResponse.prototype.setHistory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetHostHistoryResponse} returns this
 */
proto.pangolin.protos.GetHostHistoryResponse.prototype.clearHistory = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetHostHistoryResponse.prototype.hasHistory = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetHostThroughputResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetHostThroughputResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetHostThroughputResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostThroughputResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    throughput: (f = msg.getThroughput()) && proto.pangolin.protos.HostThroughputObjectList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetHostThroughputResponse}
 */
proto.pangolin.protos.GetHostThroughputResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetHostThroughputResponse;
  return proto.pangolin.protos.GetHostThroughputResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetHostThroughputResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetHostThroughputResponse}
 */
proto.pangolin.protos.GetHostThroughputResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.HostThroughputObjectList;
      reader.readMessage(value,proto.pangolin.protos.HostThroughputObjectList.deserializeBinaryFromReader);
      msg.setThroughput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetHostThroughputResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetHostThroughputResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetHostThroughputResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetHostThroughputResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThroughput();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.HostThroughputObjectList.serializeBinaryToWriter
    );
  }
};


/**
 * required HostThroughputObjectList throughput = 1;
 * @return {!proto.pangolin.protos.HostThroughputObjectList}
 */
proto.pangolin.protos.GetHostThroughputResponse.prototype.getThroughput = function() {
  return /** @type{!proto.pangolin.protos.HostThroughputObjectList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.HostThroughputObjectList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.HostThroughputObjectList} value
 * @return {!proto.pangolin.protos.GetHostThroughputResponse} returns this
*/
proto.pangolin.protos.GetHostThroughputResponse.prototype.setThroughput = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetHostThroughputResponse} returns this
 */
proto.pangolin.protos.GetHostThroughputResponse.prototype.clearThroughput = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetHostThroughputResponse.prototype.hasThroughput = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.pangolin.protos.HostHistoryDirection = {
  H_H_DIRECTION_EGRESS: 1,
  H_H_DIRECTION_INGRESS: 2,
  H_H_DIRECTION_INTERNAL: 3,
  H_H_DIRECTION_EX_OUTPUT: 4,
  H_H_DIRECTION_EX_INPUT: 5,
  H_H_DIRECTION_IN_OUTPUT: 6,
  H_H_DIRECTION_IN_INPUT: 7,
  H_H_DIRECTION_LOOPBACK: 8,
  H_H_DIRECTION_INVALID: 9
};

/**
 * @enum {number}
 */
proto.pangolin.protos.HostDeviceType = {
  H_UNKNOWN: 0,
  H_MISC: 1,
  H_DESKTOP: 2,
  H_MOBILE: 3,
  H_GAMING: 4,
  H_MEDIA: 5,
  H_NETWORK: 6,
  H_CAMERA: 7,
  H_PRINTER: 8,
  H_VPN: 9
};

goog.object.extend(exports, proto.pangolin.protos);
